import React, { useEffect, useState } from 'react'
import TextContent from '../component/TextContent/TextContent'
import Header from '../component/Header/Header'
import ClinicalConditionHome from '../component/ClinicalConditionHome/ClinicalConditionHome'
import Footer from '../component/Footer/Footer'
import ContactForm from '../component/ContactForm/ContactForm'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import Homehero from '../component/HomeHero/HomeHero'
import GoogleRatingSection from '../component/GoogleRatingSection/GoogleRatingSection'
import Contactform from '../component/Contact Form/Contactform'
import { Helmet } from 'react-helmet'
import GalleryGrid from '../component/GalleryGrid/GalleryGrid'
import ImgModal from "../component/ImgModal/ImgModal"

const treatedByLaserData = [
  `<p class="body-paragraph mb-1 pb-1"><span style="font-weight:900;font-size:1.3rem">Musculoskeletal injuries:</span> Fractures, sprains, strains, tendonitis, cartilage tears, bursitis, plantar fasciitis and other injuries to the muscles, ligaments, and joints</p>`,
  `<p class="body-paragraph mb-1 pb-1"><span style="font-weight:900;font-size:1.3rem">Post Surgical Healing:</span> Expedited healing of fractures, tendons, ligaments as well as knee and hip replacements.</p>`,
  `<p class="body-paragraph mb-1 pb-1"><span style="font-weight:900;font-size:1.3rem">Pain:</span> Back, neck, ankle, knee, hip, elbow and shoulder pain, as well as arthritis and joint pain </p>`,
  `<p class="body-paragraph mb-1 pb-1"><span style="font-weight:900;font-size:1.3rem">Neuropathic pain:</span> Disc herniation, carpal tunnel syndrome, and thoracic outlet syndrome</p>`,
  `<p class="body-paragraph mb-1 pb-1"><span style="font-weight:900;font-size:1.3rem">Repetitive strain injuries:</span> Rotator cuff tear, tennis elbow, and golfer's elbow </p>`,
  `<p class="body-paragraph mb-1 pb-1"><span style="font-weight:900;font-size:1.3rem">Wound healing:</span> scar and wound healing</p>`,
]


const gallImgUrl = [
  { source: "/images/Gallery/gall-img-1-min.jpg", position: "start" },
  { source: "/images/Gallery/gall-img-2-min.jpg", position: "top" },
  { source: "/images/Gallery/gall-img-3-min.jpg", position: "center" },
  { source: "/images/Gallery/gall-img-4-min.jpg", position: "start" },
  { source: "/images/Gallery/gall-img-5-min.jpg", position: "center right" },
  { source: "/images/Gallery/gall-img-6-min.jpg", position: "center" },
  { source: "/images/Gallery/gall-img-7-min.jpg", position: "bottom" },
  { source: "/images/Gallery/gall-img-8-min.jpg", position: "center" },
  { source: "/images/Gallery/gall-img-9-min.jpg", position: "start" },
  { source: "/images/Gallery/gall-img-10-min.jpg", position: "start" },
  { source: "/images/Gallery/gall-img-11-min.jpg", position: "start" },
  { source: "/images/Gallery/gall-img-12-min.jpg", position: "start" },
  { source: "/images/Gallery/gall-img-13-min.jpg", position: "start" },
  { source: "/images/Gallery/gall-img-14-min.jpg", position: "start" },
  { source: "/images/Gallery/gall-img-15-min.jpg", position: "start" },
  { source: "/images/Gallery/gall-img-16-min.jpg", position: "center" },
  { source: "/images/Gallery/gall-img-17-min.jpg", position: "start" },
  { source: "/images/Gallery/gall-img-18-min.jpg", position: "start" },
  { source: "/images/Gallery/gall-img-19-min.jpg", position: "start" },
  { source: "/images/Gallery/gall-img-20-min.jpg", position: "start" },
  { source: "/images/Gallery/gall-img-21-min.jpg", position: "start" },
  { source: "/images/Gallery/gall-img-22-min.jpg", position: "start" },
  { source: "/images/Gallery/gall-img-23-min.jpg", position: "start" },
  { source: "/images/Gallery/gall-img-24-min.jpg", position: "start" },
];


function Home() {
  const [bgImg,setBgImg]  = useState('/images/creatives/home-hero-bg.png')
  
  const [modal, setModal] = useState(false);
  const [imgSrc , setImgSrc] = useState("")
  const [videoModal,setVideoModal] = useState(false)

  const toggleModal = (e,vid=false) => {
    if(vid)
    {
      setVideoModal(vid)
    }
    else{
      setVideoModal(false)
      setImgSrc(e.target.id)
    }
    setModal((prev)=>{
        return !prev
    });
};

  useEffect(()=>{
    if(window.innerWidth <= 992)
    {
      setBgImg("/images/creatives/home-hero-bg-mob.png")
    }
  },[])

  return (
    <div >

    <Helmet>
        <title>
        Mobile Laser Therapy - Accelerated Healing at Your Doorstep
        </title>
        <meta name="keywords" 
        content="Mobile Laser Therapy,Laser Therapy Service,Affordable Bioflex Laser Therapy"
        ></meta>
        <link
          rel="canonical"
          href="https://www.mobilelasertherapy.ca/"
        />
        <meta
          name="description"
          content="Experience pain relief and accelerated healing with Mobile Laser Therapy. Our registered physiotherapist comes to your home, using the Bioflex Laser System for effective treatment."
        ></meta>
      </Helmet>
      
      {/* <HeroBanner 
        subHeading=""
        Heading=""
        nextLineSpanHeading=""
        Paragraph=""
        bgImg="/images/creatives/home-hero-bg.png"
        btn={false}
        btnRef=''
        btnText={""}
        sideLinks={false}
      /> */}


      {/* <div style={{position:"relative"}}>
        <div style={{position:"absolute",width:"100%",zIndex:"100"}}>
          <Header/>
        </div>
        <img src={bgImg} alt='home hero' style={{width:"100%"}}/>
        <div className='container Home-hero-bg-resp'>
          <div className='row'>
            <div className='col-lg-5' style={{position:"relative",zIndex:"0"}}>
              <h3 className='hero-section-heading text-center text-lg-start' style={{color:'#14609C'}}>PAIN RELIEF</h3>
              <h5 className='text-center text-lg-start'>AND ACCELERATED HEALING</h5>
              <img src='/images/icons/home-hero-content-icon.png' alt='arrow icon' className='d-lg-block d-none' style={{maxWidth:"200px"}} />
            </div>
            <div className='col-7'>
               <Swiper
                  spaceBetween={50}
                  autoplay={{
                    delay: 1500,
                    disableOnInteraction: false,
                  }}
                  loop={true}
                  modules={[Autoplay]}
                  breakpoints={{
                      200:{
                        slidesPerView: 1,
                      }
                    }}
                  className="mx-auto"
                  >
                      <SwiperSlide>
                      <img src="/images/creatives/home-hero-1.png" alt="home hero" />
                      </SwiperSlide>
                </Swiper>
            </div>
          </div>
        </div>
      </div> */}

      <div className='home-header-container-section' >
      <Header/>

      </div>

      <Homehero/>

      <GalleryGrid
        heading='Video Library'
        gallImgUrl={gallImgUrl}
        toggleModal={toggleModal}
        showVideosOnly={true}
      />

      

      <div className='plain-bg-bottom py-3 pt-5'>
        <div className='abstract-bg-bottom-left'>
          <div className='abstract-bg-bottom-right'>
            <TextContent
              subHeading=""
              subPara="Mobile Treatment"
              heading= "Mobile Laser Therapy is a service that will come to your home, office or facility to accelerate healing, eliminate pain and inflammation."
              content="Laser Therapy is a recognized practice covered under physiotherapy benefit plans. The medical grade laser is used exclusive to health care practitioners and is FDA approved through Health Canada."
              // btn={true}
              btn={false}
              btnText="Learn More"
              btnRef='/what-we-treat'
              shiftRow={false}
              img="/images/creatives/home-text-1.png"
              reviewContent={false}
              btnImg={false}
              fontDark={true}
              lineBetween={false}
              txtAnchor={false}
              headingH1={true}
              />
          </div>
        </div>
      </div>

      

      <TextContent
        subHeading=""
        subPara=""
        // heading= "What is Laser Therapy?"
        heading= "Why use Laser Therapy?"
        content={"Laser Therapy is now used worldwide and is also known as Low-Intensity Laser Therapy (LILT), Photobiomodulation and Cold Laser.  It is a light-based technology proven to be highly effective in the treatment of musculoskeletal problems, wound healing, and other many conditions.\nThe benefits of Laser Therapy are proven in more than 4,000 scientific papers and 500 clinical studies. The BIOFLEX® Laser Therapy system that we use utilizes scientifically developed and clinically tested protocols that maximize the effectiveness of treatment of an extensive range of clinical pathologies. Laser Technology uses superluminous and laser diodes to treat diseased or traumatized tissue with photons. These particles of energy are selectively absorbed by the cell membrane and intracellular molecules, initiating a cascade of complex physiological reactions, leading to the restoration of normal cell structure and function."}
        // btn={true}
        btn={false}
        btnText="Read More"
        btnRef='/what-we-treat'
        shiftRow={true}
        img="/images/creatives/service-text-1.png"
        // img="/images/creatives/home-text-3.png"
        reviewContent={false}
        btnImg={false}
        fontDark={true}
        lineBetween={false}
        txtAnchor={false}
        reduceBottomSpace={false}
        lazerPictureText={true}
        lazerContent={true}
        lazerContentFirst={true}
        headingH1={true}
      />
      {/* <ClinicalConditionHome/> */}

      <div 
        style={{ background: "rgb(233,246,247)",background: "radial-gradient(circle, rgba(233,246,247,1) 0%, rgba(212,241,239,1) 100%)"}}
        className='py-4 mb-0'
      >
        <TextContent
          subHeading=""
          subPara=""
          heading= "The Clinical Conditions Typically Treated by Laser Therapy"
          content={""}
          // content={"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."}
          // btnEndTel={true}
          // btnText="Book an Appointment"
          // btnRef='/contact'
          btnEnd={true}
          btnText="Read More"
          btnRef='/what-we-treat'
          shiftRow={true}
          img="/images/creatives/home-text-2.png"
          reviewContent={false}
          btnImg={false}
          fontDark={true}
          lineBetween={false}
          txtAnchor={false}
          customList={true}
          customListData={treatedByLaserData}
        />
      </div>

      <GalleryGrid
        gallImgUrl={gallImgUrl}
        toggleModal={toggleModal}
      />

      {modal ? <ImgModal status={modal} showImg={imgSrc} allImages={gallImgUrl} closeModal={toggleModal} videoModal={videoModal} /> : <></>}

      <GoogleRatingSection/>

      <Contactform
        reviewSection={true}
      />

      {/* <ContactForm/> */}

    <Footer 
      newsletterSection={false}
    />

     
</div>
  )
}

export default Home